module.exports = fox._r("components/valentines-gifts-popup/images/default/gifts-m.png", __webpack_public_path__ + "_/_/_/root/components/valentines-gifts-popup/images/default/gifts-m.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/images/default/gifts-m.png
// module id = 732
// module chunks = 4